module.exports = __webpack_public_path__ + "static/media/screen6.a9ef3a04.png";